import { switchLocalePath } from './i18n'
import { TRANSLATIONS, type Locale } from './translations'

export interface Language {
  code: Locale
  flag: string
  name: string
}

export interface LanguageLink extends Language {
  href: string
  current: boolean
}

export const LANGUAGES: Language[] = (Object.keys(TRANSLATIONS) as Locale[]).map((code) => ({
  code,
  flag: TRANSLATIONS[code]['language.flag'],
  name: TRANSLATIONS[code]['language.name'],
}))

export function languageLinks(url: string, currentLocale: Locale): LanguageLink[] {
  return LANGUAGES.map((language) => ({
    ...language,
    href: switchLocalePath(url, language.code),
    current: language.code === currentLocale,
  }))
}
